class Email {
    validate(data) {
        return {
            isValid: Boolean(data.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)),
        };
    }
}
export default Email;
